// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"b2dcf325","592":"a7491724"}[chunkId] + ".chunk.css";
};